import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { useTranslation } from "@/i18n/translations";

/**
 * Shared sticky top header — Chatity logo + language switcher + login/CTA.
 * Used on LandingPage, NotFoundPage and other public surfaces.
 */
export default function SiteHeader({ sticky = true }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <header
      className={`${sticky ? "fixed" : "relative"} w-full top-0 bg-white/95 backdrop-blur-sm border-b-2 border-black z-50`}
      data-testid="site-header"
    >
      <div className="container mx-auto px-3 md:px-4 py-3 md:py-4 flex justify-between items-center">
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-2 hover:opacity-80 transition-opacity"
          data-testid="site-header-logo"
        >
          <img src="/logo-header.png" alt="Chatity" className="h-7 md:h-9 w-auto" data-testid="header-logo-img" />
        </button>
        <div className="flex items-center gap-2 md:gap-4">
          <LanguageSwitcher />
          <Button
            onClick={() => navigate("/auth")}
            variant="outline"
            className="hidden sm:flex border-2 border-black hover:bg-black hover:text-white transition-colors"
          >
            {t("auth.login")}
          </Button>
          <Button
            onClick={() => navigate("/auth")}
            className="bg-black text-white hover:bg-gray-800 border-2 border-black text-sm md:text-base px-3 md:px-4"
          >
            {t("landing.hero.cta")}
          </Button>
        </div>
      </div>
    </header>
  );
}
